import BroadcastOnPersonalIcon from '@mui/icons-material/BroadcastOnPersonal';

export const StationIcon = BroadcastOnPersonalIcon;
